import Services from "../../services/Services";
const services = new Services(null) as any;

// toast actions
import {
  dismiss,
  update,
  error,
  message,
  warning,
  success,
  info,
} from "react-toastify-redux";

// dispatch(dismiss(id));
// dispatch(dismiss()); // dismiss all toasts
// dispatch(update(id, options));
//   dispatch(message("Default message"));
//   dispatch(success("Success message"));
//   dispatch(error("Error message"));
//   dispatch(warning("Warning message"));
//   dispatch(info("Info message"));

const GET_ASSESSMENTS = "teacherDataCenter/getInstitutionAssessments";
const TOGGLE_LOADER = "teacherDataCenter/toggleLoader";
const GET_USERTYPE_ASSESSMENTS = "teacherDataCenter/getUserTypeAssessments";
const GET_CURRENT_PROFILE = "teacherDataCenter/getTeacherProfile";
const GET_YEAR_GROUPS = "teacherDataCenter/getInstitutionYearGroups";
const GET_DEPARTMENTS = "teacherDataCenter/getInstitutionDepartments";
const GET_COHORTS = "teacherDataCenter/getCohortsList";
const GET_COHORTS_DATA = "teacherDataCenter/getCohortsListFiltered";
const GET_CURRENT_ASSESSMENT_STATS = "teacherDataCenter/getCurrentAssessmentStats";
const GET_ALERT_LEVELS_BREAKDOWN = "teacherDataCenter/getAlertLevelsBreakdown";
const UPDATE_QUERY_ARRAY = "teacherDataCenter/updateQueryArray";

const INITIAL_STATE = {
  assessments: [],
  breakdown: [],
  cohorts: [],  
  selectCohorts: [],
  currentAssessmentStats: {},
  currentProfile: {},
  yearGroups: [],
  departments: [],
  loaded: true,
  cohortsLoaded: false,
  selectedCohort: null,
  selectedAssessment: null,
  assessmentsLoaded: false,
  currentUserType: "",
  queryArray: [],

  // UI Togglers
  showAssessmentPicker: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_LOADER: 
        return {
            ...state,
            loaded: payload
        }

    case GET_ASSESSMENTS:
      return {
        ...state,
        assessments: payload,
                showAssessmentPicker: true,

      };

    // case GET_USERTYPE_ASSESSMENTS:
    //   return {
    //     ...INITIAL_STATE,
    //     assessments: payload.assessments,
    //     currentUserType: payload.usertype,
    //     currentProfile: state.currentProfile,
    //     showAssessmentPicker: true,
    //   };

    case GET_COHORTS:
      return {
        ...state,
        cohorts: payload.cohorts,
        selectCohorts: payload.cohorts,
        selectedAssessment: payload.assessmentId,
        cohortsLoaded: true,
      };

    case GET_COHORTS_DATA:
      return {
        ...state,
        cohorts: payload,
      };

    case GET_CURRENT_ASSESSMENT_STATS:
      return {
        ...state,
        currentAssessmentStats: payload.data,
        assessmentsLoaded: true,
        loaded: true,
        selectedCohort: payload.cohort,
        queryArray: payload.clearFilters ? [] : state.queryArray
      };

    case GET_ALERT_LEVELS_BREAKDOWN:
      return {
        ...state,
        breakdown: payload,
      };

    case GET_CURRENT_PROFILE:
      return {
        ...state,
        currentProfile: payload,
      };

    case GET_YEAR_GROUPS:
      return {
        ...state,
        yearGroups: payload,
      };

    case GET_DEPARTMENTS:
      return {
        ...state,
        departments: payload,
      };

    case UPDATE_QUERY_ARRAY:
      return {
        ...state,
        queryArray: payload,
      };

    default:
      return state;
  }
};

export const toggleLoader = (loaded) => dispatch => {
    dispatch({type: TOGGLE_LOADER, payload: loaded })
}

export const getInstitutionAssessments = () => async (dispatch) => {
  const res = await services.teachersAPI.getInstitutionsAssessments();
  if (res.ok) {
    dispatch({ type: GET_ASSESSMENTS, payload: res.data.assessments });
  } else {
    dispatch(error("Unable to fetch assessments at this time"));
  }
};

export const getUserTypeAssessments = (id, usertype) => async (dispatch) => {
    dispatch(toggleLoader(false));
  const res = await services.institutionsAPI.getUserTypeAssessmentList(
    id,
    usertype
  );
  if (res.ok) {
      if(!res.data.assessments.length) {dispatch(warning("These users do not have any assessments yet")); return;}
    dispatch({
      type: GET_USERTYPE_ASSESSMENTS,
      payload: { assessments: res.data.assessments, usertype },
    });
  } else {
    dispatch(error("Unable to fetch assessments at this time"));
  }
  dispatch(toggleLoader(true));
};

export const getCurrentProfile = (id) => async (dispatch) => {
  const res = await services.institutionsAPI.getInstitutionsProfile(id);
  if (res.ok) {
    dispatch({ type: GET_CURRENT_PROFILE, payload: res.data.profile });
  }
};

export const getCohortsList = (assessmentId) => async (dispatch) => {
  const res = await services.teachersAPI.getCohortsList(assessmentId);
  if (res.ok) {
    dispatch({ type: GET_COHORTS, payload: {cohorts: res.data.cohorts, assessmentId} });
    dispatch(getDepartments());
    dispatch(getYearGroups());
  }
};


export const getCohortsListFiltered = (id, assessmentId, query) => async (dispatch) => {
  const res = await services.institutionsAPI.getCohortData(id, assessmentId, query);
  if (res.ok) {
    dispatch({ type: GET_COHORTS_DATA, payload: res.data.cohorts });

  }
};

export const getYearGroups = () => async (dispatch) => {
  const res = await services.teachersAPI.getYearGroups();
  if (res.ok) {
    dispatch({ type: GET_YEAR_GROUPS, payload: res.data.yeargroups });
  }
};

export const getDepartments = () => async (dispatch) => {
  const res = await services.teachersAPI.getDepartments();
  if (res.ok) {
    dispatch({ type: GET_DEPARTMENTS, payload: res.data.departments });
  }
};

export const getCurrentAssessmentStats = (assessment, cohort, query, clearFilters = false) => async (dispatch) => {
    const res = await services.teachersAPI.getLearnersCohortAssessmentStats(assessment, cohort, query);
    if(res.ok) {
        dispatch({ type: GET_CURRENT_ASSESSMENT_STATS, payload: {data: res.data, cohort, clearFilters } });
    }
};

export const getAlertLevelsBreakdown = (assessment, cohort, query) => async (dispatch) => {
    const res = await services.teachersAPI.getLearnersAssessmentLevelsBreakdown(assessment, cohort, query);
    if(res.ok) {
        console.log({res})
        dispatch({ type: GET_ALERT_LEVELS_BREAKDOWN, payload: res.data });
    }
};

export const updateQueryArray = (arr) => (dispatch) => {
    dispatch({ type:UPDATE_QUERY_ARRAY, payload: arr});
}




// WEBPACK FOOTER //
// ./src/redux/ducks/teacherDataCenter.ts